import { render, staticRenderFns } from "./cardBill.vue?vue&type=template&id=dd756db2&"
import script from "./cardBill.vue?vue&type=script&lang=js&"
export * from "./cardBill.vue?vue&type=script&lang=js&"
import style0 from "./cardBill.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports